import http from "@/services/http";

/**
 * Cancelar consulta — endpoint da SALVIA-788.
 *
 * O endpoint existe desde 19/08, mas até 09/09 só era usado pelo assistente
 * (proposta Tier 2). A tela da agenda tinha "Excluir" e "Editar", e nenhum
 * caminho para cancelar — que é justamente o desfecho natural de uma consulta
 * recusada pela paciente (SALVIA-789, decisão D5).
 *
 * Cancelar NÃO é o mesmo que excluir: o cancelamento preserva o registro da
 * consulta e devolve o horário como vaga para o encaixe (706/707); excluir tira
 * o evento do Google Calendar.
 *
 * @param {number|string} eventId
 * @param {string} [reason] motivo (até 500 caracteres), guardado com o cancelamento
 * @returns {Promise<{success: boolean, event_id: number, status: string, message: string}>}
 */
export async function cancelarConsulta(eventId, reason) {
  const { data } = await http.post(`/api/events/${eventId}/cancel`, {
    reason: reason || null,
  });
  return data;
}
